module.exports = __webpack_public_path__ + "img/Grubenkind.105a0d5a.jpg";